export default {
    methods: {
        async reset(){
            this.$router.push({
                name: 'profile-set-password'
            })
        }
    }
}
